import React from "react";
// import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerThree from "../components/DashBoardLayerThree";


const HomePageThree = () => {
    return (
        <>
            {/* Breadcrumb */}
            <Breadcrumb title="eCommerce" />
            {/* DashBoardLayerThree */}
            <DashBoardLayerThree />
        </>
    );
};

export default HomePageThree;
